module.exports = __webpack_public_path__ + "static/img/bottom.687f86de.jpg";